import { BookingType, IProviderData, IGroupData } from "types/appointmentBooking";
import { IDay, ISlot, slotsForSelectedDay } from "../../AvailabilityShared.helpers";
import { DateTime } from "luxon";
import TimeSlotSection from "../TimeSlotSection";
import { IdNameItemModel, ProviderModel } from "types/generated/models";

interface ITimeSlotsProps {
    selectedDate: DateTime | null;
    weeks: Array<Array<IDay>>;
    selectedSlot: ISlot | null;
    slotOnChange: (slot: ISlot, selectedProvider?: IdNameItemModel) => void;
    provider: IProviderData;
    availableProviders: ProviderModel[];
    bookingType: BookingType;
    defaultStripeAccount: string;
    onProviderSelect: (providerData: IProviderData) => void;
    onGroupSelect: (groupData: IGroupData) => void;
}

export default function TimeSlots({
    selectedDate,
    weeks,
    selectedSlot,
    slotOnChange,
    provider,
    availableProviders,
    bookingType,
    defaultStripeAccount,
    onProviderSelect,
    onGroupSelect,
}: Readonly<ITimeSlotsProps>) {
    if (!selectedDate || !weeks.length) return null;

    let morningSlots: ISlot[] = [];
    let afternoonSlots: ISlot[] = [];
    let eveningSlots: ISlot[] = [];

    for (const week of weeks) {
        for (const day of week) {
            if (day.date?.equals(selectedDate)) {
                const slots = slotsForSelectedDay(day);
                morningSlots = slots.morningSlots || [];
                afternoonSlots = slots.afternoonSlots || [];
                eveningSlots = slots.eveningSlots || [];
            }
        }
    }

    return (
        <TimeSlotSection
            morningSlots={morningSlots}
            afternoonSlots={afternoonSlots}
            eveningSlots={eveningSlots}
            selectedSlot={selectedSlot}
            onSlotSelection={slotOnChange}
            provider={provider}
            availableProviders={availableProviders}
            bookingType={bookingType}
            defaultStripeAccount={defaultStripeAccount}
            onProviderSelect={onProviderSelect}
            onGroupSelect={onGroupSelect}
        />
    );
}
